import { cn } from '@monigo/ui';

export interface LogoProps {
  className?: string;
  ariaLabel?: string;
  white?: boolean;
  showBadge?: boolean;
}

/**
 * MoniGo Admin logo.
 */
export function Logo({ className, ariaLabel = 'MoniGo Admin', white, showBadge = true }: LogoProps) {
  return (
    <span
      role="img"
      aria-label={ariaLabel}
      className={cn(
        'inline-flex items-center gap-3',
        className,
      )}
    >
      <img
        src={white ? '/MONIGO_LOGO_WHITE.png' : '/monigo_logo_colored.png'}
        alt={ariaLabel}
        className="h-8 w-auto object-contain"
      />
      {showBadge ? (
        <span className="rounded-pill bg-primary/15 px-2 py-0.5 text-xs font-semibold uppercase tracking-wider text-primary">
          Admin
        </span>
      ) : null}
    </span>
  );
}
